import { ToolLoadingStateProvider } from "@/grid/ToolLoadingStateContext";
import { useAppDispatch } from "@/reducer";
import { addTephigram } from "@/reducer/TephigramState";
import { classNames } from "@/utility/jsx";
import type { GridCellLayout, TephigramSchemaOutput } from "@mm/metx-workbench.meteomatics.com";
import { Suspense, lazy, memo, useEffect } from "react";

export type GridTephigramProps = {
  tephigram: TephigramSchemaOutput;
  cellLayout: GridCellLayout;
};

export const TephigramViewLazy = memo(
  lazy(() =>
    import("@/tephigramView/index")
      .then(({ TephigramView }) => ({ default: TephigramView }))
      .catch((e) => {
        console.error(e);
        return { default: () => <div>Loading Tephigram View failed</div> };
      }),
  ),
);

const TephigramOverlay = memo(
  lazy(() =>
    import("@/overlay/overlays/default/TephigramOverlay")
      .then(({ TephigramOverlay }) => ({ default: TephigramOverlay }))
      .catch(() => {
        console.error("error");
        return { default: () => <div>Loading Tephigram Overlay failed</div> };
      }),
  ),
);

export function GridTephigram({ tephigram, cellLayout }: GridTephigramProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(addTephigram(tephigram));
  }, [dispatch, tephigram]);

  if (!tephigram) {
    return null;
  }

  return (
    <ToolLoadingStateProvider>
      <div className="overlay">
        <div className="overlay__layer">
          <Suspense fallback={<mm-loader size="large" />}>
            <TephigramViewLazy tephigram={tephigram} showStatisticTable={true} />
          </Suspense>
        </div>
        <div
          className={classNames(
            "overlay__layer",
            "gui-overlay" /*SnapshotLabelHtmlClassNames.Tephigram not ready, yet*/,
          )}
        >
          <Suspense fallback={null}>
            <TephigramOverlay plot={tephigram} cellLayout={cellLayout} />
          </Suspense>
        </div>
      </div>
    </ToolLoadingStateProvider>
  );
}
